import { comparisonRenderer } from './components/pgoComparison.js';
import { starReviewRenderer } from "./components/pgoStarRenderer.js";
import { reviewRenderer } from "./components/pgoReviewsRenderer.js";
import PgoSelection from './components/pgoSelection';
import { complaintFormHandler } from './utils/pgoComplaintUtils.js';
import { vzvzFormHandler } from './utils/vzvzUtils.js';
import { syncScroll } from "./utils/pgoScrollUtils";

const pgoInit = () => {
    const pgoId = document.querySelector('[data-pgo-id]')?.dataset.pgoId;

    const elements = {
        reviews: "#reviews",
        vzvz: "#vzvz",
        compare: "#review-compare",
        complaint: ".review-complaint",
    };

    document.addEventListener('alpine:init', () => {
        if (pgoId && document.querySelector(elements.reviews)) {
            Alpine.data('reviewRenderer', () => reviewRenderer(pgoId));
            Alpine.data('complaintFormHandler', complaintFormHandler);
        }
        if (document.querySelector(elements.compare)) {
            Alpine.data('comparisonRenderer', comparisonRenderer);
        }
        if (pgoId) Alpine.data('starReviewRenderer', () => starReviewRenderer(pgoId));
        if (document.querySelector(elements.vzvz)) Alpine.data('vzvzFormHandler', vzvzFormHandler);
    });

    if (document.querySelector(elements.compare)) document.addEventListener('alpine:initialized', syncScroll(".pgo-compare__cards", ".checklist-item-group"));

    new PgoSelection().init();
};

export default pgoInit;